// @ts-nocheck
/* Starter Sync - RecentWishLists */

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/UpdateWishList";
import { getWishListsDataView } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import addWishListToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddWishListToCart";
import deleteWishList from "@insite/client-framework/Store/Pages/MyLists/Handlers/DeleteWishList";
import deleteWishListShare from "@insite/client-framework/Store/Pages/MyLists/Handlers/DeleteWishListShare";
import updateLoadParameter from "@insite/client-framework/Store/Pages/MyLists/Handlers/UpdateLoadParameter";
import translate from "@insite/client-framework/Translate";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import CardContainer, { CardContainerStyles } from "@insite/content-library/Components/CardContainer";
import CardList, { CardListStyles } from "@insite/content-library/Components/CardList";
import TwoButtonModal from "@insite/content-library/Components/TwoButtonModal";
// import WishListCard from "@insite/content-library/Components/WishListCard"; // Starter Custom Code
import LoadingSpinner, { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import DataTable, { DataTableProps, SortOrderOptions } from "@insite/mobius/DataTable";
import DataTableBody from "@insite/mobius/DataTable/DataTableBody";
import DataTableHead from "@insite/mobius/DataTable/DataTableHead";
import DataTableHeader, { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import DataViewLoadingOverlay from "@store/Library/Components/Toolkit/DataViewLoadingOverlay";
import { LoadingOverlayProps } from "@store/MobiusOverrides/LoadingOverlay/LoadingOverlay";
import WishListCard from "@store/Overrides/Components/WishListCard";
import { tableProps } from "@store/Themes/common/props/table";
import { typographyGetNoResultsAltProps } from "@store/Themes/common/props/typography";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import usePersistentDataView from "@toolkit/Framework/Common/Hooks/usePersistentDataView";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import getWishlistShowFavorites from "@toolkit/Framework/Common/Utilities/wishlist/getWishlistShowFavorites";
import getWishlistShowTags from "@toolkit/Framework/Common/Utilities/wishlist/getWishlistShowTags";
import withHookProps, { HookPropsInjector } from "@toolkit/Framework/Common/Utilities/withHookProps";

interface HookProps {
    wishLists: ReturnType<typeof getWishListsDataView>;
    trackDeleteWishList: ReturnType<typeof ga.use.trackDeleteWishList>;
}

const hookPropsInjector: HookPropsInjector<Props, HookProps> = props => ({
    wishLists: usePersistentDataView(props.baseWishListsDataView),
    trackDeleteWishList: ga.use.trackDeleteWishList(),
});

const Pagination = getWidgetComponent("MyLists/MyListsPagination");
/* Starter Custom Code - End */

interface OwnProps extends WidgetProps {}
interface State {
    wishListToAction?: WishListModel;
    deleteListModalIsOpen: boolean;
    leaveListModalIsOpen: boolean;
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        baseWishListsDataView: getWishListsDataView(state, state.pages.myLists.getWishListsParameter), // Starter Custom Code
        getWishListsParameter: state.pages.myLists.getWishListsParameter,
    };
};

const mapDispatchToProps = {
    addWishListToCart,
    deleteWishList,
    deleteWishListShare,
    updateLoadParameter,
    updateWishList,
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps & HookProps; // Starter Custom Code

export interface MyListsListStyles {
    cardList?: CardListStyles;
    cardContainer?: CardContainerStyles;
    deleteListModal?: ModalPresentationProps;
    centeringWrapper?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    messageText?: TypographyProps;
    // Starter Custom Code
    loadingOverlay?: LoadingOverlayProps;
    wrapper?: InjectableCss;
    tableWrapper?: InjectableCss;
    dataTable?: DataTableProps;
    listNameHeader?: DataTableHeaderProps;
    dateHeader?: DataTableHeaderProps;
    itemsHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    actionsHeader?: DataTableHeaderProps;
}

export const listStyles: MyListsListStyles = {
    loadingOverlay: tableProps.loadingOverlay,
    deleteListModal: { sizeVariant: "small" },
    messageText: typographyGetNoResultsAltProps({ spaced: true }),
    tableWrapper: tableProps.wrapper,
    actionsHeader: tableProps.tightHeader,
};

const styles = listStyles;

class MyListsList extends React.Component<Props, State> {
    static contextType = ToasterContext;
    context!: React.ContextType<typeof ToasterContext>;

    constructor(props: Props) {
        super(props);
        this.state = {
            deleteListModalIsOpen: false,
            leaveListModalIsOpen: false,
        };
    }

    deleteButtonClickHandler = (wishList: WishListModel) => {
        this.setState({
            wishListToAction: wishList,
            deleteListModalIsOpen: true,
        });
    };

    deleteCancelHandler = () => {
        this.setState({ deleteListModalIsOpen: false });
    };

    deleteSubmitHandler = () => {
        this.setState({ deleteListModalIsOpen: false });
        if (this.state.wishListToAction) {
            this.props.deleteWishList({
                wishListId: this.state.wishListToAction.id,
                onSuccess: this.onDeleteSuccess,
                onComplete(resultProps) {
                    if (!resultProps.error) {
                        this.onSuccess?.();
                    }
                },
            });
        }
    };

    onDeleteSuccess = () => {
        this.context.addToast({ body: translate("List Deleted"), messageType: "success" });
        this.props.trackDeleteWishList({}, { wishList: this.state.wishListToAction }); // Starter Custom Code
    };

    leaveButtonClickHandler = (wishList: WishListModel) => {
        this.setState({
            wishListToAction: wishList,
            leaveListModalIsOpen: true,
        });
    };

    leaveCancelHandler = () => {
        this.setState({ leaveListModalIsOpen: false });
    };

    leaveSubmitHandler = () => {
        this.setState({ leaveListModalIsOpen: false });
        if (this.state.wishListToAction) {
            this.props.deleteWishListShare({
                wishList: this.state.wishListToAction,
                onSuccess: this.onLeaveSuccess,
                onComplete() {
                    this.onSuccess?.();
                },
            });
        }
    };

    onLeaveSuccess = () => {
        this.context.addToast({ body: translate("You left the list"), messageType: "success" });
    };

    toggleFavoriteClickHandler = (wishList: WishListModel) => {
        if (!wishList) {
            return;
        }

        this.props.updateWishList({
            apiParameter: {
                wishList: {
                    ...wishList,
                    isFavorite: !wishList.isFavorite,
                    wishListLineCollection: null,
                },
            },
            onComplete(resultProps) {
                if (resultProps.result?.wishList) {
                    this.onSuccess?.();
                } else if (resultProps.result?.errorMessage) {
                    this.onError?.(resultProps.result.errorMessage);
                }
            },
        });
    };

    toggleHideClickHandler = (wishList: WishListModel) => {
        if (!wishList) {
            return;
        }

        this.props.updateWishList({
            apiParameter: {
                wishList: {
                    ...wishList,
                    isHidden: !wishList.isHidden,
                    wishListLineCollection: null,
                },
            },
            onComplete(resultProps) {
                if (resultProps.result?.wishList) {
                    this.onSuccess?.();
                } else if (resultProps.result?.errorMessage) {
                    this.onError?.(resultProps.result.errorMessage);
                }
            },
        });
    };

    /* Starter Custom Code - Start */
    headerClick = (sortField: string) => {
        const sort =
            this.props.getWishListsParameter.sort === `${sortField} ASC` ? `${sortField} DESC` : `${sortField} ASC`;
        this.props.updateLoadParameter({ sort });
    };

    sorted = (sortField: string) => {
        let sorted: boolean | string = false;
        if (this.props.getWishListsParameter.sort === `${sortField} ASC`) {
            sorted = "ascending";
        } else if (this.props.getWishListsParameter.sort === `${sortField} DESC`) {
            sorted = "descending";
        }
        return sorted as SortOrderOptions;
    };
    /* Starter Custom Code - End */

    render() {
        // Starter Removed - this.props.wishLists.isLoading

        if (this.props.wishLists.value && this.props.wishLists.value.length === 0 /* Starter Custom Code */) {
            if (this.props.getWishListsParameter.page && this.props.getWishListsParameter.page > 1) {
                this.props.updateLoadParameter({ page: this.props.getWishListsParameter.page - 1 });
                return null;
            }
        }

        /* Starter Custom Code - Start */
        const wishLists = this.props.wishLists;
        const showFavorites = getWishlistShowFavorites(wishLists.value);
        const showTags = getWishlistShowTags(wishLists.value);
        /* Starter Custom Code - End */

        return (
            <DataViewLoadingOverlay dataView={wishLists} {...styles.loadingOverlay} /* Starter Custom Code */>
                {!wishLists.value?.length /* Starter Custom Code */ ? (
                    <StyledWrapper {...styles.centeringWrapper} /* Store Custom Code */>
                        <Typography
                            {...styles.messageText}
                            data-test-selector="myLists_noListsFound"
                            role={wishLists.isLoading ? "region" : "alert"} // Starter Custom Code
                        >
                            {this.props.getWishListsParameter.query
                                ? siteMessage("Lists_NoResultsMessage")
                                : siteMessage("Lists_NoListsFound")}
                        </Typography>
                    </StyledWrapper>
                ) : (
                    <>
                        {/* Store Custom Code - Start */}
                        <CardList extendedStyles={styles.cardList}>
                            {wishLists.value.map(wishList => (
                                <CardContainer key={wishList.id} extendedStyles={styles.cardContainer}>
                                    <WishListCard
                                        // Store Custom Code - Move key to the CardContainer
                                        wishList={wishList}
                                        addWishListToCart={this.props.addWishListToCart}
                                        deleteWishList={() => this.deleteButtonClickHandler(wishList)}
                                        leaveWishList={() => this.leaveButtonClickHandler(wishList)}
                                        toggleFavorite={() => this.toggleFavoriteClickHandler(wishList)}
                                        toggleHide={() => this.toggleHideClickHandler(wishList)}
                                        showFavorites={showFavorites}
                                        showTags={showTags}
                                    />
                                </CardContainer>
                            ))}
                        </CardList>
                        {/* Store Custom Code - End */}
                        <TwoButtonModal
                            modalIsOpen={this.state.deleteListModalIsOpen}
                            headlineText={translate("Delete List")}
                            messageText={`${translate("Are you sure you want to delete")} ${
                                this.state.wishListToAction ? this.state.wishListToAction.name : ""
                            }?`}
                            cancelButtonText={translate("Cancel")}
                            submitButtonText={translate("Delete")}
                            onCancel={this.deleteCancelHandler}
                            onSubmit={this.deleteSubmitHandler}
                            submitTestSelector="myListsListSubmitDelete"
                        ></TwoButtonModal>
                        <TwoButtonModal
                            modalIsOpen={this.state.leaveListModalIsOpen}
                            headlineText={translate("Leave List")}
                            messageText={`${translate("Are you sure you want to leave")} ${
                                this.state.wishListToAction ? this.state.wishListToAction.name : ""
                            }?`}
                            cancelButtonText={translate("Cancel")}
                            submitButtonText={translate("Leave")}
                            onCancel={this.leaveCancelHandler}
                            onSubmit={this.leaveSubmitHandler}
                            submitTestSelector="myListsListSubmitLeave"
                        ></TwoButtonModal>
                    </>
                )}
            </DataViewLoadingOverlay>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHookProps(MyListsList, hookPropsInjector)), // Starter Custom Code
    definition: {
        group: "My Lists",
        displayName: "List",
        allowedContexts: ["MyListsPage"],
    },
};

export default widgetModule;
